module.exports = __webpack_public_path__ + "static/media/zeitenspruenge logo-gruen.0fc30675.svg";